import { render, staticRenderFns } from "./SelfieTopHalf.vue?vue&type=template&id=020a0442&lang=pug&"
import script from "./SelfieTopHalf.vue?vue&type=script&lang=js&"
export * from "./SelfieTopHalf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports